export enum enumHtsNumberTariffStatus {
  NOT_CHANGED,
  TARIFF_CHANGED,
  TARIFF_INCREASED,
  TARIFF_DECREASED,
}
